import { useState, useEffect, useContext } from 'react';
import {ErrorContext} from '../Contexts/ErrorContext'
import ProviderService from '../Services/ProviderService';
import {extractErrorMessage} from '../Services/RequestService';
import {removeFromCollection, replaceInCollection} from './utils';

export const useProviders = () => {
    const [providers, setProviders] = useState([]);
    const token = localStorage.getItem("token");
    const {setError, success} = useContext(ErrorContext);

    const loadAll = async () => {
        try {
            const resp = await ProviderService.allProviders(token);
            setProviders(resp.data);
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const addProvider = async (provider) => {
        try {
            const resp = await ProviderService.addProvider(provider, token);
            setProviders([...providers, {...provider, id: resp.data.id}]);
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const updateProvider = async (provider, id) => {
        try {
            await ProviderService.updateProvider(provider, id, token);
            setProviders(replaceInCollection({...provider, id}, providers));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const deleteProvider = async (provider) => {
        try {
            await ProviderService.deleteProvider(provider.id, token);
            setProviders(removeFromCollection(provider, providers));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    useEffect(() => {
        loadAll()
    }, []);

    return [providers, addProvider, updateProvider, deleteProvider];
}


// WEBPACK FOOTER //
// ./src/Hooks/useProviders.js